/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Link_To_Web_Or_PdfInputs */

const en_mobile_link_to_web_or_pdf = /** @type {(inputs: Mobile_Link_To_Web_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to web page or PDF`)
};

const es_mobile_link_to_web_or_pdf = /** @type {(inputs: Mobile_Link_To_Web_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace a página web o PDF`)
};

/**
* | output |
* | --- |
* | "Link to web page or PDF" |
*
* @param {Mobile_Link_To_Web_Or_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_link_to_web_or_pdf = /** @type {((inputs?: Mobile_Link_To_Web_Or_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Link_To_Web_Or_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_link_to_web_or_pdf(inputs)
	return en_mobile_link_to_web_or_pdf(inputs)
});